import { useTRPC } from "@/trpc/client";
import { useQuery } from "@tanstack/react-query";

export function useSalesTeams(businessId: string | undefined) {
  const trpc = useTRPC();
  return useQuery(
    trpc.salesTeams.listTeams.queryOptions(
      { businessId: businessId ?? "" },
      { enabled: Boolean(businessId) },
    ),
  );
}

export function useSalesTeamsMembers(
  businessId: string | undefined,
  salesTeamId?: string | null,
) {
  const trpc = useTRPC();
  return useQuery(
    trpc.salesTeams.listMembers.queryOptions(
      {
        businessId: businessId ?? "",
        ...(salesTeamId ? { salesTeamId } : {}),
      },
      { enabled: Boolean(businessId) },
    ),
  );
}

export function useSalesTeamsMember(
  businessId: string | undefined,
  memberId: string | undefined,
) {
  const trpc = useTRPC();
  return useQuery(
    trpc.salesTeams.getMember.queryOptions(
      { businessId: businessId ?? "", memberId: memberId ?? "" },
      { enabled: Boolean(businessId && memberId) },
    ),
  );
}

export function useAssessmentSessions(
  businessId: string | undefined,
  memberId: string | undefined,
) {
  const trpc = useTRPC();
  return useQuery(
    trpc.salesTeams.listSessions.queryOptions(
      { businessId: businessId ?? "", memberId: memberId ?? "" },
      { enabled: Boolean(businessId && memberId) },
    ),
  );
}
